export default __webpack_public_path__ + "static/media/juanma-freire-1@2x.39c126d7.png";